// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_2_donationAmount_promotion_1yvc9","text":"_2_donationAmount_text_1JbqQ"};
    if(module.hot) {
      // 1789136760170
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  